
// utils/timeUtils.js
/**
 * Format arrival time to HH:MM
 * Uses the stored Peru wall time directly.
 */
export function formatArrivalTime(arrivalTime) {
  if (!arrivalTime) return '';
  
  const date = new Date(arrivalTime);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${hours}:${minutes}`;
}
